import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { PdfViewerModule, PdfViewerComponent } from 'ng2-pdf-viewer';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import { TaxFormatPipe } from './../pipe/tax-format.pipe';
import { TableComponent } from './../components/table/table.component';
import { CustomDialogComponent } from './../components/custom-dialog/custom-dialog.component';
import { CustomDialogDataComponent } from './../components/custom-dialog-data/custom-dialog-data.component';
import {RouterModule} from '@angular/router';
import { SearchComponent } from './../components/search/search.component';
import { DropdownComponent } from './../components/dropdown/dropdown.component';
import { DatePickerComponent } from './../components/date-picker/date-picker.component'
import { MonthYearPickerComponent } from './../components/month-year-picker/month-year-picker.component';
import { CardComponent } from './../components/card/card.component';
import { DateRangePickerComponent } from './../components/date-range-picker/date-range-picker.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [TableComponent, CustomDialogComponent, CustomDialogDataComponent, 
    DropdownComponent, SearchComponent, DatePickerComponent, MonthYearPickerComponent, CardComponent, DateRangePickerComponent],
  imports: [
    CommonModule,
    MatTabsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatMenuModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTooltipModule,
    MatAutocompleteModule,
    PdfViewerModule,
    RouterModule,
    FlexLayoutModule
  ],
  exports: [
    MatTabsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatMenuModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTooltipModule,
    MatAutocompleteModule,
    PdfViewerModule,
    TableComponent,
    CustomDialogComponent,
    CustomDialogDataComponent,
    RouterModule,
    SearchComponent,
    DropdownComponent,
    DatePickerComponent,
    MonthYearPickerComponent,
    CardComponent,
    DateRangePickerComponent,
    FlexLayoutModule
  ],
  providers: [  
    MatDatepickerModule,
    MatNativeDateModule,
    PdfViewerComponent,
    TaxFormatPipe,
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
  ]
})
export class MaterialModule { }